import http from '@/shared/api/http'

export async function getAllPermissions() {
  return (await http.get('admin/permissions/all')).data
}

export async function getAllRoles() {
  return (await http.get('admin/roles')).data
}

export async function getRolePermissions(roleId) {
  return (await http.get(`admin/roles/${roleId}/permissions`)).data
}

export async function assignPermissionToRole(roleId, permissionId) {
  return (await http.post(`admin/roles/${roleId}/permissions/${permissionId}`)).data
}

export async function removePermissionFromRole(roleId, permissionId) {
  return (await http.delete(`admin/roles/${roleId}/permissions/${permissionId}`)).data
}